/* eslint-disable */
<template>
    <v-container grid-list-xl fluid style="direction: rtl;padding-right: 15px">

    <v-layout row wrap >
        <v-flex lg12 sm12>
            <v-widget title="مختلف الأعمار" style="text-align: center!important;padding-right: 15px">
                <div slot="widget-content" id="q1_c" style="height:400px; " ref="q1_c">
                </div>
            </v-widget>
        </v-flex>

        <v-flex lg6 sm12 xs12>
            <v-widget title="الحالة المدنية" content-bg="white">
                <div slot="widget-content" id="main" style="height:400px; " ref="main">
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="المستوى الدراسي" content-bg="white">
                    <div slot="widget-content" id="q6" style="height:400px;" ref="q6"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="الحالة المدنية مع إعتبار المستوى الدراسي">
                <div slot="widget-content" id="q1_2" style="height:400px; " ref="q1_2">
                </div>
            </v-widget>
        </v-flex>
        <!-- liste child-->
        <v-flex lg3 sm12 xs12>
            <v-widget title="عدد الأبناء في الكفالة" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q7.nbr0)
                                    color="success"

                            >

                                {{q7.nbr0}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 إبن</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q7.nbr1)
                                    color=cyan darken-2

                            >

                                {{q7.nbr1}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q7.nbr2)
                                    color=deep-orange

                            >
                                {{q7.nbr2}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 2 أقل من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q7.nbr_moins5)
                                    color=purple lighten-2
                            >

                                {{q7.nbr_moins5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value= caption2(q7.nbr_plus5)

                                    color=black


                            >

                                {{q7.nbr_plus5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="عدد الأبناء الذين يزاولون التعليم" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr0)
                                    color="success"
                            >
                                {{q8.nbr0}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 إبن</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr1)
                                    color=cyan darken-2
                            >
                                {{q8.nbr1}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr2)
                                    color=deep-orange
                            >
                                {{q8.nbr2}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 2 أقل من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{q8.nbr_moins5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr_plus5)
                                    color=black

                            >
                                {{q8.nbr_plus5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="عدد الأبناء الذين يعملون" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr0)
                                    color="success"
                            >
                             {{   q9.nbr0    }}     %                   </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 إبن</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr1)
                                    color=cyan darken-2
                            >
                                {{q9.nbr1}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr2)
                                    color=deep-orange
                            >
                               {{q9.nbr2}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 2 أقل من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{ q9.nbr_moins5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr_plus5)
                                    color=black

                            >
                                {{ q9.nbr_plus5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="عدد الأبناء في حالة بطالة" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr0)
                                    color="success"
                            >
                       {{q10.nbr0}}%
                            </v-progress-circular>
                        </div>

                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 إبن</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr1)
                                    color=cyan darken-2
                            >
                                {{q10.nbr1}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr2)
                                    color=deep-orange
                            >
                                {{q10.nbr2}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 2 أقل من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{q10.nbr_moins5}}%


                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr_plus5)
                                    color=black

                            >
                                {{q10.nbr_plus5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="عدد الأبناء المتزوجون" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr0)
                                    color="success"
                            >
                                {{q11.nbr0}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 إبن</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr1)
                                    color=cyan darken-2
                            >
                                {{q11.nbr1}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr2)
                                    color=deep-orange
                            >
                                {{q11.nbr2}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 2 أقل من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{q11.nbr_moins5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr_plus5)
                                    color=black

                            >
                                {{q11.nbr_plus5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="عدد الأبناء ذي الإحتياجات الخصوصية" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr0)
                                    color="success"
                            >
                                {{q12.nbr0}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 إبن</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr1)
                                    color=cyan darken-2
                            >
                                {{q12.nbr1}}%


                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 أبناء</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr2)
                                    color=deep-orange
                            >
                                {{q12.nbr2}}%


                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 2 أقل من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{q12.nbr_moins5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">أكثر من 5</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr_plus5)
                                    color=black

                            >
                      {{q12.nbr_plus5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>

        <v-flex lg3 sm12 xs12>
            <v-widget title="معدل الأطفال الذين يدرسون" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">طفل لكل إمرأة</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(qf)*10
                                    color=pink darken-3
                            >
                                {{qf}}طفل
                            </v-progress-circular>
                        </div>
                    </div></div></v-widget></v-flex>

        <v-flex lg6 sm12 xs12>
            <v-widget title="إعانات">
                <div slot="widget-content">
                    <linear-statistic
                            title=" النساء اللواتي لا يتمتعون بإعانات ظرفية أو موسمية"
                            sub-title=""
                            color=red darken-2

                            :value=caption2(q16)
                    >
                    </linear-statistic>

                    <linear-statistic
                            title="النساء اللواتي لا يتمتعون بإعانات مدرسية أو جامعية للأبنائ المتمدرسين"
                            sub-title=""
                            color=red darken-2
                            :value=caption2(q17)
                    >
                    </linear-statistic>
                    <linear-statistic
                            title=" أبناء يتعاطون نفس النشاط "
                            sub-title=""
                            color="success"
                            :value=caption2(q13)
                    >
                    </linear-statistic>

                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>

            <circle-statistic

                    caption=""
                    sub-title="نساء تملك دخل ثان "
                    title=""
                    color=purple lighten-2
                    :value=caption2(tt)
            >
                {{tt}} %
            </circle-statistic>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="مختلف الدخل الثاني للنساء">
                    <div slot="widget-content" id="q15" style="height:400px; " ref="q15">
                    </div>
            </v-widget>
        </v-flex>

        <v-flex lg6 sm12 xs12>
            <v-widget title="مكان وضع الأطفال أثناء العمل">
                <div slot="widget-content" id="q14" style="height:400px; " ref="q14">
                </div>
            </v-widget>
        </v-flex>

        <v-flex lg6 sm12 xs12>
            <v-widget title="طبيعة المسكن">
                <div slot="widget-content" id="q18" style="height:400px; " ref="q18">
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="ملكية المسكن">
                <div slot="widget-content" id="q19" style="height:400px; " ref="q19"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="حالة المسكن">
                <div slot="widget-content" id="q20" style="height:400px; " ref="q20"></div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="تجهيزات" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">تلفاز</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.tele)
                                    color=pink darken-3
                            >
                               {{q21.tele}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">ثلاجة</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.fre)
                                    color=pink darken-3
                            >
                            {{q21.fre}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">حاسوب</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.pc)
                                    color=pink darken-3
                            >
                                {{q21.pc}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">فرن</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.four)
                                    color=pink darken-3
                            >
                                {{q21.four}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">غسالة</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.machine)
                                    color=pink darken-3
                            >
                         {{q21.machine}}%
                            </v-progress-circular>
                        </div>
                    </div>

                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <circle-statistic
                    title=""
                    sub-title="أرض صالحة للزراعة"
                    caption=""
                    color="purple"
                    :value=caption2(q22) >
            </circle-statistic>
        </v-flex>

        <v-flex lg3 sm12 xs12>
            <v-widget title="تكوين أو إختصاص" content-bg="white">
                <div slot="widget-content">
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">نساء تمتعن بتكوين</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q23)
                                    color=cyan darken-2
                            >
                                {{q23}}%


                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">نساء يرغبن في تكوين</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q24)
                                    color=deep-orange
                            >
                                {{q24}}%


                            </v-progress-circular>
                        </div>
                    </div>

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">لديهن فكرة مشروع</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q25)
                                    color=black

                            >
                                {{q25}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
    </v-layout>
    </v-container>
</template>

<script>
    import EChart from '@/components/chart/echart';
    import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
    import PostListCard from '@/components/widgets/card/PostListCard';
    import ProfileCard from '@/components/widgets/card/ProfileCard';
    import PostSingleCard from '@/components/widgets/card/PostSingleCard';
    import WeatherCard from '@/components/widgets/card/WeatherCard';
    import PlainTable from '@/components/widgets/list/PlainTable';
    import PlainTableOrder from '@/components/widgets/list/PlainTableOrder';
    import VWidget from '@/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import VCircle from '@/components/circle/VCircle';
    import BoxChart from '@/components/widgets/chart/BoxChart';
    import ChatWindow from '@/components/chat/ChatWindow';
    import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
    import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
    var echarts = require('../../node_modules/echarts');
    import {
        StackData,
        SinData,
        monthVisitData,
        campaignData,
        locationData,
    } from '@/api/chart';
    import MiniChart from '@/components/widgets/chart/MiniChart';

    /* eslint-disable */
    export default {
        name: "q1-compenent",
        components: {
            VWidget,
            MiniStatistic,
            ChatWindow,
            VCircle,
            WeatherCard,
            PostSingleCard,
            PostListCard,
            ProfileCard,
            EChart,
            BoxChart,
            CircleStatistic,
            LinearStatistic,
            PlainTable,
            PlainTableOrder,
            MiniChart,

        },
        data() {
            return {
                selectedTab: 'tab-1',
                option: null,
                dataset: {
                    sinData: SinData,
                    monthVisit: monthVisitData,
                    campaign: campaignData,
                    location: locationData,
                    stackData: StackData,
                },
                state :this.$route.params.state,
                color: Material,
                q5:'',
                q15_a:'0',
                q19:'',
                q7:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q8:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                qf:0,
                q9:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q10:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q11:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q12:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q21:{
                    tele:'0',
                    fre:'0',
                    pc:'0',
                    four:'0',
                    machine:'0'
                },
                tt:0,
                q13:'',
                q16:0,
                q17:0,
                q22:0,
                q23:0,
                q24:0,
                q25:0,
                data5:[],   data6:[], datam:[], datac:[], datav:[], datad:[],
            }
        },
        watch: {
            $route: function(newVal, oldVal) {
                this.fetchData()
            }
        },

        computed: {
            activity() {
                return API.getActivity();
            },
            posts() {
                return API.getPost(3);
            },
            siteTrafficData() {
                return API.getMonthVisit;
            },
        },
        created(){



        },
        mounted(){
            this.fetchData()

        },
        methods: {
            caption2 (val) {
                return val *1;
            },
            fetchData() {
                var labelOption1 = {

                    normal: {
                        fontSize: 16,
                        fontWeight:"bold"
                    }
                };
                console.log("aaaaaaaaaa");
                const ECharts = window.echarts || undefined;
                if (ECharts === undefined) {
                    console.error('ECharts is not defined');
                }

                var myChart12 = ECharts.init(this.$refs.q1_2, 'material');
                var myChart = ECharts.init(this.$refs.main, 'material');
                var myChart2 = ECharts.init(this.$refs.q6, 'material');
                var myChart3 = ECharts.init(this.$refs.q14, 'material');
                var myChart4 = ECharts.init(this.$refs.q15, 'material');
                var myChart9 = ECharts.init(this.$refs.q1_c, 'material');
                var myChart5 = ECharts.init(this.$refs.q18, 'material');
                var myChart6 = ECharts.init(this.$refs.q19, 'material');
                 var myChart7 = ECharts.init(this.$refs.q20, 'material');
/*
                 var myChart13 = ECharts.init(this.$refs.qf, 'material');
*/

                myChart.showLoading();
                myChart2.showLoading();
                myChart3.showLoading();
                myChart4.showLoading();
                myChart5.showLoading();
                myChart6.showLoading();
                myChart7.showLoading();
                myChart9.showLoading();
                myChart12.showLoading();
                var formData = new FormData();
                 if((this.$route.params.state)=='الكل'){
                     formData.append('pays','');
                 }
             else {
                formData.append('pays',this.$route.params.state);
                 }
                 console.log(formData.pays)
                this.$http.post('https://acg-generations.com/acg_laravel/public/question5',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                    var data = response.bodyText
                    var obj = JSON.parse(data);

                    this.q5=obj.q5;
                    this.q6=obj.q6;
                    this.q7=obj.q7;
                    this.q8=obj.q8;
                    this.q9=obj.q9;
                    this.q10=obj.q10;
                    this.q11=obj.q11;
                    this.q12=obj.q12;

                    this.q13=obj.q13;
                    this.q14=obj.q14;
                    this.q15=obj.q15;
                    this.tt=obj.q15.total;
                    this.q15_a=obj.q15_a;
                    this.q16=obj.q16;
                    this.q17=obj.q17;
                    this.q18=obj.q18;
                    this.q19=obj.q19;
                    this.q20=obj.q20;
                    this.q21=obj.q21;
                    this.q22=obj.q22;
                    this.q23=obj.q23;
                    this.q24=obj.q24;
                    this.q24=obj.q24;
                    this.q25=obj.q25;
                    this.qf=obj.qf;
                    this.q1_c=obj.q1_c;
                    for(var i=0;i<this.q1_c.length;i++){
                        this.data5[i]=this.q1_c[i].q1_c
                        this.data6[i]=this.q1_c[i].total
                    };
                    this.qm=obj.qm;
                        this.datam[0]=this.qm.a
                        this.datam[1]=this.qm.b
                        this.datam[2]=this.qm.c
                        this.datam[3]=this.qm.d
                    this.qc=obj.qc;
                    this.datac[0]=this.qc.a
                    this.datac[1]=this.qc.b
                    this.datac[2]=this.qc.c
                    this.datac[3]=this.qc.d
                    this.qv=obj.qv;
                    this.datav[0]=this.qv.a
                    this.datav[1]=this.qv.b
                    this.datav[2]=this.qv.c
                    this.datav[3]=this.qv.d
                    this.qd=obj.qd;
                    this.datad[0]=this.qd.a
                    this.datad[1]=this.qd.b
                    this.datad[2]=this.qd.c
                    this.datad[3]=this.qd.d


                    myChart.hideLoading();
             myChart2.hideLoading();
             myChart3.hideLoading();
             myChart4.hideLoading();
             myChart5.hideLoading();
             myChart6.hideLoading();
             myChart7.hideLoading();
             myChart9.hideLoading();
             myChart12.hideLoading();
                    var arrayq5=[
                        {value:this.q5.a, label: labelOption1,  name:'أرملة'},
                        {value:this.q5.c, label: labelOption1, name:'متزوجة'},
                        {value:this.q5.d, label: labelOption1,  name:'مطلقة'},

                        {value:this.q5.b, label: labelOption1,  name:'عزباء'},
                    ]
                    var count=this.q5.count;

                    myChart.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return Math.round(arrayq5[id].value * 0.01 *count)+' '  ;
                            }
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['أرملة','عزباء','متزوجة','مطلقة'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],

                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq5
                        }]
                    });
                    /**********************************************/
                    var arrayq6=[
                        {value:this.q6.a, label: labelOption1, name:'ابتدائي'},
                        {value:this.q6.d, label: labelOption1,name:'جامعي'},

                        {value:this.q6.b, label: labelOption1, name:'امية'},
                        {value:this.q6.c, label: labelOption1,name:'ثانوي'},
                    ];
                    var count=this.q6.count;
                    myChart2.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return  Math.round(arrayq6[id].value * 0.01 *count)+' '  ;
                            }
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['ابتدائي','امية','ثانوي','جامعي'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: '70%',
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq6
                        }]
                    });
                    /***********************************************/
                    var arrayq14 =[
                        {value:this.q14.b,label: labelOption1, name:'الحضانة'},

                        {value:this.q14.a, label: labelOption1,name:'الجدين'},
                        {value:this.q14.c,label: labelOption1,name:'مكان اخر'},
                    ]
                    var count=this.q14.count;

                    myChart3.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return  Math.round(arrayq14[id].value * 0.01 *count)+' '  ;
                            }

                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['الجدين','الحضانة','مكان اخر'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                            },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: '70%',
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },

                            data:arrayq14
                        }]
                    });
                    var labelOption = {
                        normal: {
                            show: true,
                            position:"insideBottom",
                            align: "left",
                            verticalAlign: "middle",
                            rotate: 90,
                            formatter: '{c}% ',
                            fontSize: 16,
                            rich: {
                                name: {
                                    textBorderColor: '#fff'
                                }
                            }
                        }
                    };
                    var labelOption7 = {
                        normal: {
                            show: true,
                            position:"Bottom",
                            align: "top",
                            verticalAlign: "middle",
                            rotate: 0,
                            formatter: '{c}% : {a}',
                            fontSize: 16,
                            rich: {
                                name: {
                                    textBorderColor: '#fff'
                                }
                            }
                        }
                    };
                    var labelOption16 = {
                        normal: {
                            show: true,
                            position:"insideBottom",
                            align: "left",
                            verticalAlign: "middle",
                            rotate: 90,
                            formatter: '{c}% : {a}',
                            fontSize: 16,
                            fontWeight:"bold"
                        }
                    };
/*********************************************/
                    myChart4.setOption({


                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return  ''  ;
                            }

                        },
                        legend: {
                            bottom: '0',
                            data:['جراية ارامل','جراية ايتام','محصول فلاحي','منحة عائلات معوزة'],
                            label:{
                                fontSize: 16,
                            },

                        },

                        toolbox: {
                            show: true,
                            orient: 'vertical',
                            left: 'right',
                            top: 'center',
                        }, xAxis: [
                            {
                                axisTick: {show: true,
                                    alignWithLabel: true,
                                    label:true
                                },
                                data: [],
                            }
                        ],
                        yAxis: [
                            {
                                name:'%',
                                type: 'value'
                            }
                        ],
                        series: [

                            { data:[this.q15.a], type: 'bar',label: labelOption,name:'جراية ارامل'},
                            { data:[this.q15.b],  type: 'bar',label: labelOption,name:'جراية ايتام'},
                            { data:[this.q15.c], type: 'bar',label: labelOption,name:'محصول فلاحي'},
                            { data:[this.q15.d], type: 'bar',label: labelOption,name:'منحة عائلات معوزة'},
                        ]
                    });

                    /*********************************************/
                    var arrayq18=[
                        {value:this.q18.a,label: labelOption1, name:'ريفي'},
                        {value:this.q18.b,label: labelOption1, name:'شعبي'},
                        {value:this.q18.c,label: labelOption1,name:'فيلا'},
                    ]
                    var count=this.q18.count;

                    myChart5.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return   Math.round(arrayq18[id].value * 0.01 *count)+' '  ;
                            }
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['ريفي','شعبي','فيلا' ],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: '70%',
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq18
                        }]
                    });
                    /*********************************************/
                    var arrayq19=[
                        {value:this.q19.d,label: labelOption1,name:'ملك'},
                        {value:this.q19.c,label: labelOption1,name:'كراء'},
                        {value:this.q19.a, label: labelOption1,name:'جماعي'},
                        {value:this.q19.b, label: labelOption1,name:'على وجه الفضل'},
                    ]
                    var count= this.q19.count;
                    myChart6.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return   Math.round(arrayq19[id].value * 0.01 *count)+' '  ;
                            }
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['جماعي','على وجه الفضل','كراء','ملك' ],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },


                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq19
                        }]
                    });
                    /*********************************************/
                    var arrayq20=[
                        {value:this.q20.a, label: labelOption1,name:'حسنة'},
                        {value:this.q20.b, label: labelOption1,name:'رثة'},
                        {value:this.q20.c,label: labelOption1,name:'متوسطة'},

                    ]
                    var count=this.q20.count
                    myChart7.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return Math.round(arrayq20[id].value * 0.01 *count)+' '  ;
                            }
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['حسنة','رثة','متوسطة'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: '70%',
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq20
                        }]
                    });

                    /*********************************************/
                    myChart9.setOption({
                        tooltip : {
                            trigger: 'axis',
                            axisPointer:{
                                show: true,
                                type : 'cross',
                                lineStyle: {
                                    width : 1
                                }
                            }
                        },
                        xAxis: {
                            name:'مختلف الأعمار',
                            type: 'category',
                            axisTick: {
                                alignWithLabel: true
                            },
                            data: this.data5,
                        },
                        yAxis: {
                            name:'عدد',

                            type: 'value'
                        },

                        series: [{
                            name:'العدد',
                            data: this.data6,
                            type: 'bar',
                        }]
                    });
                    /*********************************************/
                    myChart12.setOption({
                        color: [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            },
                            show: 'true'
                        },
                        legend: {data: ['متزوجة', 'مطلقة', 'أرملة', 'عزباء'],},
                        xAxis: {type: 'value'},
                        yAxis: { type: 'category',
                            data: ['ابتدائي', 'امية', 'ثانوي', 'جامعي']
                            },

                        series: [
                            {
                                name: 'متزوجة',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    color: '#fff',

                                    normal: {
                                        show: true,
                                        position: 'inside',
                                    }
                                },
                                data: this.datam,
                            },
                            {
                                name: 'أرملة',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    color: '#fff',
                                    normal: {
                                        show: true,
                                        position: 'inside'
                                    }
                                },
                                data: this.datav,
                            },
                            {

                                name: 'عزباء',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    color: '#fff',
                                    normal: {
                                        show: true,
                                        position: 'inside'
                                    }
                                },
                                data: this.datac,
                            },
                            {
                                name: 'مطلقة',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    color: '#fff',
                                    normal: {
                                        show: true,
                                        position: 'inside'
                                    }
                                },
                                data: this.datad,
                            },


                        ]
                    });


                    /*********************************************/
                }, response => {
                    // error callback
                });
            },


        }
    }
</script>

<style scoped>

    .legend {
        width: 100%;
        position: absolute;
        top: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/table1.vue